import React, { useEffect, useState } from 'react'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import './Cataloge.sass'
import test from './metal.svg'
import { NavLink } from 'react-router-dom'
import getCollection from '../../utils/db/getCollection'
import { find, isNull, orderBy } from 'lodash'

function Cataloge() {
  const [cats, setCats] = useState(null)

  const data = [
    {
      title: 'Металобрухт',
      desc: 'Приймаємо чорний та кольоровий металобрухт',
      avatar: test,
    },
  ]

  useEffect(() => {
    getCollection({
      path: 'services',
      docIdName: 'serviceId',
      whereQueries: [{ fieldPath: 'isDeleted', op: '!=', value: true }],
    }).then((result) => setCats(orderBy(result, ['pos'], ['asc'])))
    // promiseAllValues({
    //   categories: getCollection({
    //     path: 'settings/price/categories',
    //     docIdName: 'categoryId',
    //     whereQueries: [{ fieldPath: 'isDeleted', op: '!=', value: true }],
    //   }),
    //   services: getCollection({
    //     path: 'settings/price/services',
    //     docIdName: 'serviceId',
    //     whereQueries: [{ fieldPath: 'isDeleted', op: '!=', value: true }],
    //   }),
    // }).then((result) => {
    //   const cats = orderBy(result.categories, ['pos'], ['asc'])
    //   cats.forEach((c, i) => {
    //     if (i === 0 && isEmpty(el)) {
    //       c.isActive = true
    //     }

    //     if (!isEmpty(el) && el[1] === c.categoryId) {
    //       c.isActive = true
    //     }

    //     c.services = orderBy(
    //       result.services.filter((s) => s.categoryId === c.categoryId),
    //       ['pos'],
    //       ['asc']
    //     )
    //   })
    //   setServices(cats)
    // })
  }, [])

  return (
    <section id="cataloge" name="cataloge" className="Cataloge">
      <div className="DefaultContainer">
        <SectionTitle title="Каталог послуг"></SectionTitle>
        <div className="Cataloge-Body">
          {!isNull(cats) && cats.map((c) => <CatalogeTile {...c} />)}
        </div>
      </div>
    </section>
  )
}

function CatalogeTile({ serviceId, photos, title, descShort }) {
  const avatar = find(photos, ['isAvatar', true])
    ? find(photos, ['isAvatar', true]).publicUrl
    : null
  return (
    <NavLink to={`/service/${serviceId}`}>
      <div
        className="CatalogeTile"
        style={{ backgroundImage: `url(${avatar})` }}
      >
        <div className="Content">
          <div className="Title">{title}</div>
          <div className="Description">{descShort}</div>
        </div>
      </div>
    </NavLink>
  )
}

export default Cataloge
